import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService as AuthGuard } from './services/auth-guard/auth-guard.service';
import { SubmitOtpLaterComponent } from './otp/submit-otp-later/submit-otp-later.component';
import { MyRecentActivitesComponent } from './recent-activites/my-recent-activites/my-recent-activites.component';
import { NotificationComponent } from './notification/notification.component';
import { HomeComponent } from './reports/home/home.component';
// import { ConfigurationsComponent } from './configurations/configurations.component';
import { OnLogoutComponent } from './logout/on-logout/on-logout.component';
import { ErrorMainComponent } from './error-components/error/error.component';



import { PreApprovalNotificationComponent } from './notification/pre-approval-notification/pre-approval-notification.component';
import { OnlineCustomerNotificationComponent } from './notification/online-customer-notification/online-customer-notification.component';

import { BroadcastMessageComponent } from './notification/broadcast-message/broadcast-message.component';
import { FaqComponent } from './faq/faq.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  // { path: 'login', component: LoginComponent, pathMatch: 'full' },
  {
    path: 'login', loadChildren: './modules/login/login.module#LoginModule'
  },
  {
    path: 'home', loadChildren: './modules/home-page-module/home-page-module.module#HomePageModuleModule'
  },
  { path: 'form', loadChildren: './modules/form1/form1.module#Form1Module' },
  {
    path: 'search', loadChildren: './modules/search-module/search-module.module#SearchModuleModule',
  },
  {
    path: 'track', loadChildren: './modules/track-application-module/track-application-module.module#TrackApplicationModuleModule'
  },
  {
    path: 'doc', loadChildren: './modules/doc-upload-module/doc-upload-module.module#DocUploadModuleModule'
  },

  { path: 'approvalStatus', loadChildren: './modules/approval-status/approval-status.module#ApprovalStatusModule' },
  { path: 'submitOtp', component: SubmitOtpLaterComponent, pathMatch: 'full' },
  { path: 'error', component: ErrorMainComponent, pathMatch: 'full' },
  { path: 'logout', component: OnLogoutComponent, pathMatch: 'full' },
  { path: 'dataSync', loadChildren: './modules/admin-module/admin-module.module#AdminModuleModule' },

  { path: 'broadcastAdmin', loadChildren: './modules/broadcast-admin-module/broadcast-admin-module.module#BroadcastAdminModuleModule' },
  { path: 'dealerData', loadChildren: './modules/dealerdata-module/dealerdata-module.module#DealerdataModuleModule' },
  { path: 'dashboardAdmin', loadChildren: './modules/dashboard-admin-module/dashboard-admin-module.module#DashboardAdminModuleModule' },
  { path: 'configAdmin', loadChildren: './modules/config-admin-module/config-admin-module.module#ConfigAdminModuleModule' },

  { path: 'createRule', loadChildren: './modules/create-rule/create-rule.module#CreateRuleModule' },
  { path: 'editRule', loadChildren: './modules/edit-rule/edit-rule.module#EditRuleModule', data: {} },

  { path: 'imageuploads', loadChildren: './modules/image-uploads-module/image-uploads-module.module#ImageUploadsModuleModule' },

  { path: 'userAdmin', loadChildren: './modules/user-module/user-module.module#UserModuleModule' },
  { path: 'userAdd', loadChildren: './modules/user-add-module/user-add-module.module#UserAddModuleModule' },

  { path: 'taskManager', loadChildren: './modules/task-manager-module/task-manager-module.module#TaskManagerModuleModule' },
  { path: 'faqConfig', loadChildren: './modules/faq-module/faq-module.module#FaqModuleModule' },



  { path: 'faq', component: FaqComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: 'recentActivities', component: MyRecentActivitesComponent, pathMatch: 'full', canActivate: [AuthGuard] },

  { path: 'reports', component: HomeComponent, pathMatch: 'full' },
  {
    path: 'preapprovals', component: PreApprovalNotificationComponent, pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'onlinecustomer', component: OnlineCustomerNotificationComponent, pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'broadcastMessage', component: BroadcastMessageComponent, pathMatch: 'full',
  },
  {
    path: 'notifications', component: NotificationComponent, pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: '**', component: PagenotfoundComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
